

import { abibApi, tags, methods } from '.';
import { CountryWithRelations, CountryListFilter, CountryListItem, CountryRating, ListQuery, ListState, SuccessResponse, CountryDeprecated } from '../types';

export const apiCountry = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCountries: builder.query<ListState<CountryListItem>, any>({
      query: () => {
        return {
          method: methods.GET,
          url: `/countries/simplified`,
        };
      },
      providesTags: (result, error, params) => [tags.countryList],
      transformResponse: ({ data }, meta, params) => ({
        items: data as CountryListItem[],
      }),
    }),
    getAllCountryRatings: builder.query<{ items: CountryRating }, any>({
      query: () => {
        return {
          method: methods.GET,
          url: `/countries/ratings/simplified`,
        };
      },
      providesTags: (result, error, params) => [tags.countryRatingList],
      transformResponse: ({ data }, meta, params) => ({
        items: data
      }),
    }),
    getCountryList: builder.query<ListState<CountryListItem, CountryListFilter>, ListQuery<CountryListFilter>>({
      query: ({ page, perPage, filter }) => {
        return {
          method: methods.GET,
          url: `/countries?page=${page || 1}&perPage=${perPage || 10}&filter=${JSON.stringify(filter || {})}`,
        };
      },
      providesTags: (result, error, params) => [tags.countryList],
      transformResponse: ({ data, meta: { links, path, ...pagination } }: SuccessResponse<CountryListItem[]>, meta, { filter }) => ({
        filter: filter,
        items: data,
        pagination: pagination,
      }),
    }),
    getCountry: builder.query<CountryWithRelations, { country_id: number | string }>({
      query: ({ country_id }) => {
        return {
          method: methods.GET,
          url: `/countries/${country_id}`,
        };
      },
      providesTags: (result, error, { country_id }) => [{ type: tags.country, country_id }],
      transformResponse: ({ data }, meta, { country_id }) => data,
    }),
    getCountryDeprecated: builder.query<CountryDeprecated, { country_id: number | string }>({
      query: ({ country_id }) => {
        return {
          method: methods.GET,
          url: `/deprecated/countries/${country_id}`,
        };
      },
      providesTags: (result, error, { country_id }) => [{ type: tags.country, country_id }],
      transformResponse: ({ data }, meta, { country_id }) => data,
    }),
  }),
  overrideExisting: false,
});


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllCountriesQuery,
  useGetAllCountryRatingsQuery,
  useGetCountryQuery,
  useGetCountryDeprecatedQuery,
  useGetCountryListQuery,

  useLazyGetAllCountriesQuery,
  useLazyGetAllCountryRatingsQuery,
  useLazyGetCountryQuery,
  useLazyGetCountryDeprecatedQuery,
  useLazyGetCountryListQuery,
} = apiCountry;
